import { useCallback } from 'react'
import { IOrderedShipmentStopFragment } from '../../graphql/OrderedShipmentStop'
import { useRearrangeShipmentStopsMutation } from '../../graphql/RearrangeShipmentStops'
import { useErrors } from '../useErrors'
import { getStopsInput } from './utils'

export const useRearrangeStops = () => {
  const { errorMessages, setErrors } = useErrors()
  const [_rearrangeStops, state] = useRearrangeShipmentStopsMutation()

  const rearrangeStops = useCallback(
    async (
      pickupStops: IOrderedShipmentStopFragment[],
      deliveryStops: IOrderedShipmentStopFragment[]
    ) => {
      setErrors([])
      try {
        const input = getStopsInput(pickupStops, deliveryStops)
        const response = await _rearrangeStops({ variables: { input } })

        const { data } = response || {}
        const { rearrangeShipmentStops } = data || {}
        const { errors: apiErrors = [] } = rearrangeShipmentStops || {}
        setErrors(apiErrors)

        if (apiErrors.length) {
          return false
        }

        return true
      } catch (e) {
        return false
      }
    },
    [_rearrangeStops, setErrors]
  )

  return {
    ...state,
    rearrangeStops,
    errorMessages,
  }
}
